var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextBox = function SvgTextBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M25.965 14.369V22.821C25.965 23.375 25.516 23.824 24.962 23.824H7.03901C6.48501 23.824 6.03601 23.375 6.03601 22.821V20.461M6.03497 16.675V8.25202C6.03497 7.69802 6.48397 7.24902 7.03797 7.24902H24.961C25.515 7.24902 25.964 7.69802 25.964 8.25202V10.168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M10.9 11.2531H21.099M16 11.2531V20.0921"
  })));
};
export default SvgTextBox;